<template>
    <div>
        <div class="container mt-12">
            <h1 class="text-4xl font-heading font-bold md:text-5xl">
                Your Dashboard
            </h1>

            <div class="grid gap-6 lg:grid-cols-2 mt-12">
                <div class="p-6 rounded-lg border-3 border-teal-dark">
                    <div class="row">
                        <div class="col">
                            <h2 class="text-3xl font-heading font-bold text-teal-dark md:text-4xl">
                                Next booked course:
                            </h2>
                            <h3 class="text-2xl font-heading font-bold text-teal-dark mt-1 md:text-3xl">
                                <CalendarFormat v-if="nextSession" :date="nextSession.start_date" :showState="false"/>
                                <span v-else>-</span>
                            </h3>
                        </div>
                        <div class="col-auto">
                            <div class="p-4 rounded-full bg-green md:p-5">
                                <svg class="text-teal-dark w-8 h-8 md:w-12 md:h-12" viewBox="0 0 46.097 46.097">
                                    <path
                                        d="M985.816,527H952.29a6.291,6.291,0,0,0-6.29,6.29v33.526a6.289,6.289,0,0,0,6.29,6.281h33.527a6.287,6.287,0,0,0,6.281-6.281V533.29a6.289,6.289,0,0,0-6.281-6.29ZM990,566.816A4.2,4.2,0,0,1,985.816,571H952.29a4.2,4.2,0,0,1-4.2-4.187V533.29a4.21,4.21,0,0,1,4.2-4.2h33.527a4.2,4.2,0,0,1,4.187,4.2Zm0,0"
                                        transform="translate(-946 -527)" fill="currentColor"/>
                                    <path
                                        d="M955.937,531.58a1.777,1.777,0,1,1-1.781-1.779,1.78,1.78,0,0,1,1.781,1.779Zm0,0"
                                        transform="translate(-941.237 -524.91)" fill="currentColor"/>
                                    <path
                                        d="M961.741,531.58a1.78,1.78,0,1,1-1.781-1.779,1.78,1.78,0,0,1,1.781,1.779Zm0,0"
                                        transform="translate(-936.911 -524.91)" fill="currentColor"/>
                                    <path
                                        d="M967.542,531.58a1.781,1.781,0,1,1-1.781-1.779,1.782,1.782,0,0,1,1.781,1.779Zm0,0"
                                        transform="translate(-932.582 -524.91)" fill="currentColor"/>
                                    <rect width="6.426" height="5.715" transform="translate(15.552 18.021)"
                                          fill="currentColor"/>
                                    <rect width="6.419" height="5.715" transform="translate(24.126 18.021)"
                                          fill="currentColor"/>
                                    <rect width="6.419" height="5.715" transform="translate(32.695 18.021)"
                                          fill="currentColor"/>
                                    <rect width="6.419" height="5.71" transform="translate(6.985 25.649)"
                                          fill="currentColor"/>
                                    <rect width="6.426" height="5.71" transform="translate(15.552 25.649)"
                                          fill="currentColor"/>
                                    <rect width="6.419" height="5.71" transform="translate(24.126 25.649)"
                                          fill="currentColor"/>
                                    <rect width="6.419" height="5.71" transform="translate(32.695 25.649)"
                                          fill="currentColor"/>
                                    <rect width="6.419" height="5.703" transform="translate(6.985 33.275)"
                                          fill="currentColor"/>
                                    <rect width="6.426" height="5.703" transform="translate(15.552 33.275)"
                                          fill="currentColor"/>
                                    <rect width="6.419" height="5.703" transform="translate(24.126 33.275)"
                                          fill="currentColor"/>
                                    <rect width="6.419" height="5.703" transform="translate(32.695 33.275)"
                                          fill="currentColor"/>
                                </svg>
                            </div>
                        </div>
                    </div>
                    <div v-if="nextSession"  class="mt-8 md:mt-12 md:text-xl">
                        <h3 class="font-bold">{{ nextSession.course.title }}</h3>
                        <p class="mt-2">{{ nextSession.course.summary }}</p>
                    </div>

                </div>
                <div class="p-6 text-center rounded-lg bg-gradient-to-r from-teal-dark to-teal text-white">
                    <h2 class="text-3xl font-heading font-bold md:text-4xl">
                        allegro.EXCEL credits earned to date:
                    </h2>

                    <div
                        class="inline-flex justify-center items-center min-w-44 mt-8 py-2 px-4 font-bold text-teal rounded-full bg-white border border-teal md:py-3 md:px-6">
                        <svg class="w-5 h-5 text-pink fill-current md:w-7 md:h-7" viewBox="0 0 19.744 19.006">
                            <path
                                d="M16.043 19.006l-6.175-3.9-6.175 3.9L5.5 11.931 0 7.259l7.166-.472 2.7-6.788 2.7 6.788 7.174.472-5.5 4.672z"/>
                        </svg>
                        <div class="inline-block font-heading mt-1 ml-2 md:mt-0 md:text-2xl">
                            {{ user.credits || 0 }} CREDITS
                        </div>
                    </div>

                    <p class="mt-8 md:text-xl md:mt-12">
                        <router-link
                            :to="{name: 'courses.completed'}"
                            class="font-bold text-white underline hover:text-white">
                            Click here
                        </router-link> to view all courses you have attended
                    </p>
                </div>
            </div>

            <h2 class="mt-16 text-3xl text-center font-heading font-bold">
                Your upcoming courses
            </h2>

            <div class="mt-12 space-y-10">
                <CoursePanel v-for="course in upcomingCourses" :key="course.id" :course="course"/>
                <div v-if="!upcomingCourses.length" class="border-2 border-dashed border-gray-200 p-4 text-center">
                    <p>Nothing to display</p>
                </div>
            </div>
        </div>
        <div v-if="relevantCourses && relevantCourses.length" class="mt-16 bg-gray-300 py-12">
            <div class="container">

                <div class="prose max-w-none text-center">
                    <h2>Courses that may interest you...</h2>
                </div>

                <CourseCarousel :courses="relevantCourses" class="mt-8"/>
            </div>
        </div>
    </div>
</template>

<script>

import axios from "axios";
import Store from "@/Store"
import {mapGetters} from "vuex";
import CoursePanel from "@/Components/CoursePanel"
import CourseCarousel from "@/Components/CourseCarousel"
import CalendarFormat from "@/Components/CalendarFormat"

export default {

    name: "DashboardPage",

    data() {
        return {
            upcomingCourses: [],
            nextSession: null,
            relevantCourses: [],
        }
    },

    components: {
        CoursePanel,
        CourseCarousel,
        CalendarFormat
    },

    methods: {
        setData(data) {

            this.upcomingCourses = data.upcoming_courses;
            this.nextSession = data.next_session;
            this.relevantCourses = data.relevant_courses;

            this.$store.dispatch('fetchUser');
        },
    },

    computed: {
        ...mapGetters([
            'user',
        ])
    },

    async beforeRouteEnter(to, from, next) {
        if (!Store.getters.isStudent) {
            next({name: 'admin.courses.index'})
        } else {
            const data = (await axios.get(route('api.student-dashboard'))).data;
            next(vm => vm.setData(data));
        }
    },

    async beforeRouteUpdate(to, from) {
        if (!Store.getters.isStudent) {
            next({name: 'admin.courses.index'})
        } else {
            const data = (await axios.get(route('api.student-dashboard'))).data;
            this.setData(data);
        }
    }
};

</script>
